module.exports = __webpack_public_path__ + "static/kitchen-app-948acf9c26ef10f5ee4d3f624e86a2f1.mp4";